<template lang="pug">
section.territorio
    BaseHeader(
        :titulo="$t('mensagens.territorio.titulo')",
        icon='el-icon-plus',
        :btnTexto="$t('mensagens.territorio.cadastrarTerritorio')",
        :exibeBotao='true',
        @btnHeaderClicado='cadastrarTerritorio'
    )

    .view-container-base-header
        .lista-territorios__barra-pesquisa
            i.el-icon-search
            input.lista-territorios__barra-pesquisa__input(
                v-if='ff1183CodigoLyraTerritorio',
                v-model='search',
                type='text',
                :placeholder="$t('mensagens.territorio.procurePeloTerritorioCodigoLyra')",
                autocomplete='off',
                @keyup.enter='onChangeSearchInput'
            )
            input.lista-territorios__barra-pesquisa__input(
                v-else,
                v-model='search',
                type='text',
                :placeholder="$t('mensagens.territorio.procurePeloTerritorio')",
                autocomplete='off',
                @keyup.enter='onChangeSearchInput'
            )

        .table
            el-table.table-territorios(
                height='100%',
                :data='territorios',
                v-loading='loadingTerritorio',
                @sort-change='sortChangeRequest',
                style='width: 100%'
            )
                el-table-column(type='expand')
                    template(slot-scope='props')
                        el-descriptions.descricao-item-tabela(:size='"mini"')
                            el-descriptions-item(
                                :label="$t('mensagens.territorio.labels.pessoasProdutores')",
                                v-if='props.row.representantes && props.row.representantes.length > 1'
                            )
                                .representantes(
                                    v-for='representante in props.row.representantes',
                                    :key='representante.id'
                                )
                                    p {{ representante.nomeRazaoSocial }}
                                        span ({{ representante.cpfCnpj }})
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.representantes && props.row.representantes.length === 1'
                        )
                            el-descriptions-item.has-colon-not(
                                :label="$t('mensagens.territorio.territorioNaoPossuiPessoasAdicionais')"
                            )

                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.representantes && props.row.representantes.length === 0'
                        )
                            el-descriptions-item.has-colon-not(
                                :label="$t('mensagens.territorio.territorioNaoPossuiPessoas')"
                            )

                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.comercializacoes.length'
                        )
                            el-descriptions-item(:label="$t('mensagens.territorio.comercializacoes')")
                                ul.comercializacoes-infor-lista
                                    li.comercializacoes-infor(
                                        v-for='(comercializao, index) in props.row.comercializacoes',
                                        :key='index'
                                    )
                                    li.comercializacoes-infor
                                        span.lista-comercializacao {{ comercializao.produto.nome }} - {{ comercializao.quantidade }} ({{ comercializao.unidadeMedida.simbolo }})
                                        span.lista-comercializacao Número do contrato: {{ comercializao.numeroContrato }}
                                        span.lista-comercializacao Fornecedor: {{ comercializao.fornecedor }}
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.certificacoes.length'
                        )
                            el-descriptions-item(:label="$t('mensagens.territorio.certificacoes')")
                                ul.comercializacoes-infor-lista
                                    li.comercializacoes-infor(
                                        v-for='(certificacao, index) in props.row.certificacoes',
                                        :key='index'
                                    ) {{ certificacao.nome }}

                        el-descriptions.descricao-item-tabela(:size='"mini"')
                            el-descriptions-item(
                                label='CAR:',
                                v-if='props.row.cars && props.row.cars.length > 1'
                            )
                                .car-list-row
                                    .cars(
                                        v-for='car in props.row.cars',
                                        :key='car.codigo'
                                    )
                                        p {{ car.codigo }}
                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.cars && props.row.cars.length === 1'
                        )
                            el-descriptions-item.has-colon-not(
                                :label="$t('mensagens.territorio.territorioNaoPossuiCarsAdicionais')"
                            )

                        el-descriptions.descricao-item-tabela(
                            :size='"mini"',
                            v-if='props.row.cars && props.row.cars.length === 0'
                        )
                            el-descriptions-item.has-colon-not(
                                :label="$t('mensagens.territorio.territorioNaoPossuiCars')"
                            )

                el-table-column(
                    prop='nome',
                    :label="$t('mensagens.territorio.labels.territorio')",
                    min-width='200px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome }}

                el-table-column(
                    prop='representante',
                    :label="$t('mensagens.territorio.labels.pessoasDocumento')",
                    min-width='200',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        .representante(
                            v-if='scope.row.representantes && scope.row.representantes.length > 0'
                        )
                            p {{ scope.row.representantes[0].nomeRazaoSocial }}
                                span ({{ formatCpfCnpj(scope.row.representantes[0].cpfCnpj) }})
                                el-popover(
                                    v-if='scope.row.representantes.length > 1',
                                    placement='bottom',
                                    trigger='hover'
                                )
                                    el-tag.ml-2(size='mini', slot='reference')
                                        | {{ scope.row.representantes.length }}
                                    .lista-scroll
                                        div(
                                            v-for='(representante, index) in scope.row.representantes',
                                            :key='index'
                                        ) {{ representante.nomeRazaoSocial }}
                                            span ({{ formatCpfCnpj(representante.cpfCnpj) }})
                        .representante(v-else)
                            p -

                el-table-column(
                    prop='localidade',
                    :label="$t('mensagens.territorio.labels.localidade')",
                    min-width='200px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p {{ scope.row.localidade }}

                el-table-column(
                    :formatter='formatAreaHaTableColumn',
                    prop='areaHa',
                    :label="$t('mensagens.territorio.labels.areaHa')",
                    min-width='150px',
                    sortable='custom'
                )

                el-table-column(
                    prop='codigo',
                    :label="$t('mensagens.territorio.labels.car')",
                    min-width='300px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        .car(
                            v-if='scope.row.cars && scope.row.cars.length > 0'
                        )
                            p.car-hiden-row {{ scope.row.cars[0].codigo }}
                            el-popover(
                                v-if='scope.row.cars.length > 1',
                                placement='bottom',
                                trigger='hover'
                            )
                                el-tag.ml-2(size='mini', slot='reference') {{ scope.row.cars.length }}
                                .lista-scroll
                                    div(
                                        v-for='(car, index) in scope.row.cars',
                                        :key='index'
                                    ) {{ car.codigo }}
                        .car(v-else)
                            p -

                el-table-column(
                    prop='idCliente',
                    :label="$t('mensagens.territorio.labels.idCliente')",
                    min-width='110px',
                    sortable='custom'
                )
                    template(slot-scope='scope')
                        p(v-if='scope.row.idCliente') {{ scope.row.idCliente }}
                        p(v-else) -

                el-table-column(
                    prop='dataCadastroFormatada',
                    :label="$t('mensagens.territorio.labels.dataCadastro')",
                    min-width='120px',
                    sortable='custom'
                )

                el-table-column(
                    v-if='ff1183CodigoLyraTerritorio',
                    prop='codigoLyra',
                    :label="$t('mensagens.territorio.labels.codigoLyra')",
                    min-width='120px',
                    sortable='custom'
                )

                el-table-column(
                    :label="$t('mensagens.territorio.labels.acoes')",
                    width='200px',
                    fixed='right',
                    align='center'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(
                            @click.native='setAtivo(scope.row)',
                            trigger='click'
                        )
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='goToTerritorioDashboard(scope.row)'
                                ) {{ $t('mensagens.comuns.visualizar') }}

                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='handleClickUpdate(scope.row)'
                                ) {{ $t('mensagens.comuns.editar') }}

                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='handleClickDelete(scope.row)'
                                ) {{ $t('mensagens.comuns.remover') }}

                                el-dropdown-item(
                                    v-if='usuarioLogado.monitoramentoAccess && usuarioLogado.monitoramentoEnviar',
                                    icon='el-icon-map-location',
                                    @click.native='handleClickSendToMonitormaneto(scope.row)'
                                ) {{ verificaMonitoramento }}

                                el-dropdown-item(
                                    icon='flow flow-environment',
                                    @click.native='goToDiagnosticoSocioambiental(scope.row)'
                                ) {{ $t('mensagens.territorio.diagnosticoSocioambiental') }}

                                el-dropdown-item(
                                    icon='el-icon-download',
                                    @click.native='baixarKMLTerritorio(scope.row)'
                                ) {{ $t('mensagens.territorio.baixarPoligono') }}

                template(slot='empty')
                    el-empty(
                        :description="$t('mensagens.territorio.voceNaoPossuiTerritoriosCadastrados')"
                    )

            .tabela-rodape
                .tabela-rodape--esquerda
                    p {{ totalTerritorios }} {{ $t('mensagens.territorio.territorios') }}

                .tabela-rodape--pagination
                    el-pagination(
                        background,
                        :page-size='paginacao.tamanhoPagina',
                        :current-page.sync='paginacao.paginaAtual',
                        layout='prev, pager, next',
                        :total='totalTerritorios',
                        @current-change='fetchTerritorios'
                    )

    #modal-delete-territorio-are-you-sure.row(v-if='deleteTerritorioModal')
        el-dialog(:visible.sync='deleteTerritorioModal', width='500px')
            span(slot='title')
                h1.mb-2.font-weight-bold(style='text-align: left') Remover território
            .column.d-flex.justify-content-center.align-items-center.flex-column
                p.mb-5.texto-modal(v-if='statusMonitoramento === "ATIVO"')
                    | {{ $t('mensagens.territorio.naoFoiPossivelRemoverTerritorioEmMonitoramento') }}

                p.mb16.texto-modal(
                    v-else-if='statusMonitoramento === "CANCELADO"'
                )
                    b.mb-2 Atenção!
                    br
                    | {{ $t('mensagens.territorio.territorioPossuiMonitoramentosCancelados') }}

                p.mb16.texto-modal(v-else)
                    | {{ $t('mensagens.territorio.desejaRemoverTerritorio') }}

                .buttons.mb16(v-show='statusMonitoramento !== "ATIVO"')
                    BaseButton(
                        size='mini',
                        @click='handleCloseModalDeleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.cancelar') }}
                    BaseButton(
                        type='primary',
                        size='mini',
                        @click='deleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.remover') }}

    ModalEditarTerritorio(
        :mostrar='showModalEditarMonitoramento',
        :data='monitoramentosTerritorio',
        @fechar='fecharEditarTerritorio',
        @editar='editTerritorio'
    )

    SendOrEditMonitoramento(
        v-if='showMonitoramentoModal',
        :showMonitoramentoModal='showMonitoramentoModal',
        :selectedTerritorioNome='selectedTerritorio.nome',
        :selectedTerritorio='territorioParaMonitoramento',
        actionType='send'
    )

</template>

<script>
import ModalEditarTerritorio from '@/components/territorio/modalEditarTerritorio';
import BaseHeader from '@/components/BaseHeader';
import EmptyResult from '@/components/EmptyResult';
import SendOrEditMonitoramento from '@/components/areamonitorada/SendOrEditMonitoramento';
import { required } from 'vuelidate/lib/validators';
import territorioService from '@/services/TerritorioService';
import MonitoramentoService from '@/services/MonitoramentoService';
import AuthService from '@/services/AuthService';
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import { mapActions, mapGetters } from 'vuex';
import UtilsService from '@/services/UtilsService';
import { isEmpty } from 'lodash';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { formatFlag } from '@/utils/featureFlags/featureFlag';
import { FeatureFlagConst } from '@/constants/FeatureFlag';

export default {
    name: 'index',
    components: {
        BaseHeader,
        EmptyResult,
        SendOrEditMonitoramento,
        ModalEditarTerritorio,
        BaseButton
    },
    data() {
        return {
            territorios: [],
            totalTerritorios: 0,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 20
            },
            isAdding: false,
            territorio: {
                nomeTerritorio: null,
                nomeProdutorCpfCnpj: null,
                cityState: null,
                area: null
            },
            addTerritorioSuccess: false,
            search: null,
            deleteTerritorioModal: false,
            selectedTerritorio: {},
            selectedAction: null,
            territorioParaMonitoramento: {
                idTerritorio: null,
                cultura: null,
                dataPlantio: null,
                areaDoPlantio: null,
                idSafra: null,
                produtividade: null
            },
            statusMonitoramento: '',
            order: null,
            nomeColumn: null,
            verificaMonitoramento: false,
            usuarioLogado: null,
            loadingTerritorio: false,
            showModalEditarMonitoramento: false,
            monitoramentosTerritorio: [],
            ff1183CodigoLyraTerritorio: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF1183_CODIGO_LYRA_TERRITORIO))
        };
    },
    validations: {
        territorio: {
            nomeTerritorio: {
                required
            }
        },
        territorioParaMonitoramento: {
            idSafra: { required }
        }
    },

    async created() {
        await this.fetchUsuarioLogado();
        await this.fetchTerritorios();

        this.resetTerritorio();
        this.clearTerritoryTableData();
    },
    filters: {
        formatarAreaDuasCasas: function (value) {
            if (!value) return '';
            const valueString = value.toString();
            return (
                Math.round(Number(valueString.replace(',', '.')) * 100) / 100
            ).toFixed(2);
        }
    },

    computed: {
        ...mapGetters(['showMonitoramentoModal', 'territorioData'])
    },

    methods: {
        ...mapActions([
            'setTerritorio',
            'setEdicaoSimplesTerritorio',
            'clearTerritorio',
            'clearTerritoryTableData',
            'changeShowMonitoramentoModal',
            'setRecriarMonitoramentos'
        ]),

        fecharEditarTerritorio() {
            this.showModalEditarMonitoramento = false;
            this.monitoramentosTerritorio = [];
        },

        resetTerritorio() {
            this.$v.$reset();
            this.territorio = {};
        },

        async setAtivo(value) {
            if (this.usuarioLogado.monitoramentoAccess) {
                const response = await MonitoramentoService.verificarTerritorio(
                    value.id
                );
                const data = await response.data;
                if (!isEmpty(data)) {
                    this.verificaMonitoramento = this.$t('mensagens.territorio.atualizarMonitoramento');
                } else {
                    this.verificaMonitoramento = this.$t('mensagens.territorio.enviarParaMonitoramento');
                }
            }
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.search = this.search || '';

            if (validators.validarCPF(this.search)) {
                filtro.search = formatters.documentoFormatToNumeral(this.search);
            }

            filtro.order = '&sort=nome,asc';
            if (this.order && this.nomeColumn) {
                const nomesColunas = {
                    nome: 'nome_territorio',
                    representante: 'nome_representante',
                    localidade: 'nome_nivel2',
                    areaHa: 'territorio_area',
                    dataCadastroFormatada: 'territorio_data_cadastro',
                    idCliente: 'territorio_id_cliente',
                    codigo: 'codigo_car',
                    codigoLyra: 'codigo_lyra'
                };
                const sort = nomesColunas[this.nomeColumn];
                filtro.order = `&sort=${sort},${this.order}`;
            }
            return filtro;
        },

        async fetchUsuarioLogado() {
            await AuthService.isLogged().then(({ data }) => {
                this.usuarioLogado = data;
            });
        },

        async fetchTerritorios() {
            this.loadingTerritorio = true;
            let filtro = this.getFiltros();

            const { data } = await territorioService.findAll(filtro);
            this.totalTerritorios = data.totalElements;
            this.territorios = data.content;
            this.loadingTerritorio = false;
        },

        cadastrarTerritorio() {
            this.territorioData.value = 'add';
            this.$router.push({ name: 'CadastrarEditarTerritorio' });
        },

        goToTerritorioDashboard({ id }) {
            this.$router.push({
                name: 'VisualizarTerritorio',
                params: { idTerritorio: id }
            });
        },

        async handleClickUpdate(value) {
            try {
                MonitoramentoService.verificarTerritorio(value.id).then(response => {
                    if (response.status === 200) {
                        const ativos = response.data.filter(d => d.statusVegaApi === 'ATIVO');
                        if (ativos.length > 0) {
                            this.showModalEditarMonitoramento = true;
                            this.monitoramentosTerritorio = ativos;
                        } else {
                            this.editTerritorio(value, false);
                        }
                    } else if (response.status === 204) {
                        this.editTerritorio(value, false);
                    }
                });
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.erroAoVerificarMonitoramentosTerritorio')
                });
            }
        },

        editTerritorio(value, simples, monitoramentos) {

            try {
                territorioService.findById(value.id).then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        result.value = 'edit';
                        this.territorio = result;
                        this.setTerritorio(result);
                        this.setEdicaoSimplesTerritorio(simples);

                        if (monitoramentos && monitoramentos.length > 0) {
                            this.setRecriarMonitoramentos(monitoramentos);
                        }
                                                    
                        this.$router.push({ name: 'CadastrarEditarTerritorio' });
                        
                    }
                });
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.erroAoVerificarStatusMonitoramentos')
                });
            }

        },

        deleteTerritorio() {
            territorioService
                .delete(this.selectedTerritorio.id)
                .then(response => {
                    if (response.status === 200) {
                        this.deleteTerritorioModal = false;
                        this.fetchTerritorios();
                        this.$notify.success({
                            message: this.$t('mensagens.territorio.removidoComSucesso')
                        });
                    } else {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.erroAoRemoverTerritorio')
                        });
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.erroAoRemoverTerritorio')
                    });
                });
        },

        async handleClickDelete({ id }) {
            try {
                const { data } = await territorioService.getStatusMonitoramento(
                    id
                );

                this.statusMonitoramento = data;
                this.selectedTerritorio.id = id;
                this.deleteTerritorioModal = true;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.erroAoVerificarStatusMonitoramentos')
                });
            }
        },

        handleCloseModalDeleteTerritorio() {
            this.deleteTerritorioModal = false;
        },

        onChangeSearchInput() {
            this.paginacao.paginaAtual = 1;
            this.fetchTerritorios();
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        formatAreaHaTableColumn(row, column, areaHa, index) {
            return formatters.maxFormatNumber(areaHa, 2);
        },

        handleClickSendToMonitormaneto(value) {
            this.selectedTerritorio = value;
            this.territorioParaMonitoramento.idTerritorio =
                this.selectedTerritorio.id;
            this.changeShowMonitoramentoModal();
        },

        sendToMonitoramento() {
            this.$v.territorioParaMonitoramento.$touch();
            if (this.$v.territorioParaMonitoramento.$invalid) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.preenchaCampoObrigatorio')
                });
            } else {
                MonitoramentoService.envioAreaMonitoramento(
                    this.territorioParaMonitoramento
                )
                    .then(response => {
                        if (response.status === 200) {
                            this.$notify.success({
                                message: this.$t('mensagens.territorio.enviadoMonitoramentoComSucesso')
                            });

                            this.$router.push({ name: 'Monitoramento' });
                        } else {
                            this.$notify.error({
                                message: this.$t('mensagens.territorio.erroAoEnviarTerritorioMonitoramento')
                            });
                        }
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t('mensagens.territorio.erroAoEnviarTerritorioMonitoramento')
                        });
                    });
            }
        },

        goToDiagnosticoSocioambiental({ id }) {
            this.$router.push({
                name: 'TerritorioSocioambiental',
                params: { idTerritorio: id }
            });
        },

        sortChangeRequest(column) {
            this.order = null;

            if (column.order === 'ascending') {
                this.order = 'asc';
            } else if (column.order === 'descending') {
                this.order = 'desc';
            }

            this.nomeColumn = column.prop;
            this.fetchTerritorios();
        },

        baixarKMLTerritorio({ id }) {
            territorioService.findById(id).then(({ data }) => {
                UtilsService.baixarKMLdeGeometria(data.geometria);
            });
        },

        formatMunicipio(municipio) {
            if (municipio) {
                return (
                    formatters.utf8Decode(municipio.nome) +
                    ' - ' +
                    formatters.utf8Decode(municipio.estado.sigla)
                );
            }

            return '--';
        }
    }
};
</script>

<style lang="scss">
.territorio {
    height: 100%;
    width: 100%;

    button {
        width: fit-content;
        cursor: pointer;
    }

    .lista-territorios__barra-pesquisa {
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        background-color: var(--white);
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        i.el-icon-search {
            color: var(--primary);
            font-size: 25px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-territorios__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .required-text {
        color: var(--danger);
    }

    #end-add-territorio-button {
        p {
            cursor: pointer;
        }
    }

    .el-table {
        border-radius: 5px 5px 0 0 !important;

        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .table-territorios {
        height: 100%;
        width: 100%;
        background-color: var(--white);
        border-radius: $default-border-radius;
        border-color: var(--default-border-color);
    }

    .table {
        height: calc(100vh - 312px);

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 0 0 5px 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }
    }

    .el-dialog__body {
        padding: 5px 20px;
        color: var(--text-disabled);
        font-size: 14px;
        word-break: break-all;
    }

    .buttons {
        width: 100%;
        gap: 16px;
        display: flex;
        justify-content: space-between;
    }

    .vw-100 {
        width: 100%;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }
}

.lista-scroll {
    max-height: 300px;
    overflow-y: auto;
    flex-direction: column;
    padding: 5px 10px;

    /* width */
    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: var(--text-disabled);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }
}

#modal-delete-territorio-are-you-sure {
    text-align: center;
}

#modal-diagnostico-socioambiental {
    text-align: center;

    word-break: keep-all !important;
}

.mb16 {
    margin-bottom: 16px;
}

.justify-content-between.mb-3 {
    display: flex;
    margin-top: 25px;
}

ul.comercializacoes-infor-lista {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    flex-direction: row;
}

.comercializacoes-infor {
    margin-right: 29px;
}

.texto-modal {
    word-break: break-word !important;
}

.ajuste-comercializacao {
    margin-left: -15px !important;
}

.lista-comercializacao {
    padding-right: 24px;
    display: inline-flex;
}

</style>
